<template>
    <v-layout row wrap>
        <v-flex xs12 sm6 md4 px-4>
            <v-dialog
                ref="dialogDate"
                v-model="modalDate"
                :return-value.sync="date"
                persistent
                lazy
                full-width
                :hide-overlay="true"
                width="290px">

                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="formatedDate"
                        label="Escolha o dia"
                        prepend-icon="event"
                        readonly
                        v-on="on">
                    </v-text-field>
                </template>

                <v-date-picker v-model="date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="modalDate = false">Cancelar</v-btn>
                    <v-btn flat color="white" @click="$refs.dialogDate.save(date)">OK</v-btn>
                </v-date-picker>
            </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md4 px-4>
            <v-dialog
                ref="dialogTime"
                v-model="modalTime"
                :return-value.sync="time"
                persistent
                lazy
                full-width
                width="290px">

                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="time"
                        label="Hora do início"
                        prepend-icon="access_time"
                        readonly
                        v-on="on">
                    </v-text-field>
                </template>

                <v-time-picker
                    v-if="modalTime"
                    v-model="time"
                    full-width>

                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="modalTime = false">Cancel</v-btn>
                    <v-btn flat color="white" @click="$refs.dialogTime.save(time)">OK</v-btn>
                </v-time-picker>
            </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md4 px-4>
            <v-dialog
                ref="dialogTimeEnd"
                v-model="modalTimeEnd"
                :return-value.sync="timeEnd"
                persistent
                lazy
                full-width
                width="290px">

                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="timeEnd"
                        label="Hora de encerramento"
                        prepend-icon="access_time"
                        readonly
                        v-on="on">
                    </v-text-field>
                </template>
                <v-time-picker
                    v-if="modalTimeEnd"
                    v-model="timeEnd"
                    full-width>

                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="modalTimeEnd = false">Cancel</v-btn>
                    <v-btn flat color="white" @click="$refs.dialogTimeEnd.save(timeEnd)">OK</v-btn>
                </v-time-picker>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    props: [ 'value', 'currentItem' ],
    data() {
        return {
            modalDate: false,
            modalTime: false,
            modalTimeEnd: false,
            date: '',
            time: '',
            timeEnd: ''
        }
    },
    created() {
        if( typeof this.$props.currentItem.date != 'undefined' ) {
            this.date = this.$props.currentItem.date.split('/').reverse().join('-');
            this.time = this.$props.currentItem.time;
            this.timeEnd = this.$props.currentItem.timeEnd;
        }
    },
    computed: {
        formatedDate() {
            return this.date.split('-').reverse().join('/');
        }
    },
    watch: {
        date() {
            this.change();
        },
        time() {
            this.change();
        },
        timeEnd() {
            this.change();
        }
    },
    methods: {
        change() {
            this.$emit('change', {
                date: this.formatedDate,
                time: this.time,
                timeEnd: this.timeEnd
            });
        }
    }
}
</script>